package meineglasfaser.frontend.www.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.ariaLabel
import com.varabyte.kobweb.compose.css.role
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.navigation.Anchor
import meineglasfaser.frontend.common.components.widgets.PromLogo
import meineglasfaser.frontend.common.components.widgets.PromLogoType
import meineglasfaser.frontend.common.components.widgets.ThemeToggle
import meineglasfaser.frontend.www.components.layouts.CONTAINER_CLASS
import meineglasfaser.frontend.www.components.widgets.CustomerAccountPill
import org.jetbrains.compose.web.dom.*

@Composable
fun PortalHeader() {
    val ctx = rememberPageContext()
    Header(attrs = { classes(CONTAINER_CLASS) }) {
        IncidentBanner()
        Nav(attrs = {
            role("navigation")
            ariaLabel("Hauptnavigation")
        }) {
            Ul {
                Li {
                    Anchor(href = "/") {
                        PromLogo(PromLogoType.MAIN_COMPACT)
                    }
                }
                Li {
                    H1 { Text("Kundenportal") }
                }
            }
            Ul {
                Li {
                    ThemeToggle()
                }
                Li {
                    CustomerAccountPill()
                }
            }
        }
    }
}
